import template from './connectSms.template.html';
import templateAddAsNote from './addToTicketAsNote.template.html';

export default {
  template,
controller: class controller {
    constructor(
      $filter,
      $rootScope,
      $mdDialog,
      $sessionStorage,
      authenticationService,
      eventService,
      messagesService,
      smsService,
      workflowsService,
      notesService,
      ticketsService,
      uiService
    ) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.currentOrganization = null;
      ctrl.currentAccount = null;
      ctrl.currentTimeZone = null;
      ctrl.currentDateFormat = null;
      ctrl.currentTimeFormat = null;

      ctrl.contact = null;
      ctrl.sender = '';
      ctrl.senders = [];
      ctrl.phone = '';
      ctrl.templates = [];

      if (!$sessionStorage.SmsMessages) {
        // eslint-disable-next-line no-param-reassign
        $sessionStorage.SmsMessages = [];
      }
      ctrl.archive = $sessionStorage.SmsMessages;
      ctrl.message = '';
      ctrl.isSendingMessage = false;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.isAuthenticated = authenticationService.isAuthenticated();
        if (ctrl.isAuthenticated) {
          ctrl.currentOrganization = $rootScope.CurrentOrganization;
          ctrl.currentAccount = $rootScope.CurrentAccount;
          ctrl.currentTimeZone = $rootScope.CurrentTimeZone();
          ctrl.currentLocale = $rootScope.CurrentLocale();
          ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
          ctrl.currentTimeFormat = $rootScope.CurrentTimeFormat();
        }
        ctrl.senders = [];

        if (authenticationService.isAuthenticated()) {
          if (ctrl.currentAccount.getPhone()) {
            ctrl.senders.push({
              id: ctrl.currentAccount.id,
              name: ctrl.currentAccount.getName(),
              phone: ctrl.currentAccount.getPhone()
            });
            ctrl.switchSender(ctrl.currentAccount.id);
          }
          if (ctrl.currentOrganization.organization.shorthand) {
            ctrl.senders.push({
              id: ctrl.currentOrganization.id,
              name: ctrl.currentOrganization.getName(),
              phone: ctrl.currentOrganization.organization.shorthand
            });
            if (!ctrl.currentAccount.getPhone()) {
              ctrl.switchSender(ctrl.currentOrganization.id);
            }
          }
          messagesService.getAvailable({ type: ['sms'] }).then((messages) => {
            ctrl.templates = messages;
          });
        }
      };
      ctrl.appendPhone = (number) => {
        ctrl.phone = `${ctrl.phone}${number}`;
      };
      ctrl.erasePhone = (whole) => {
        if (whole) {
          ctrl.phone = '';
        } else {
          ctrl.phone = ctrl.phone.slice(0, -1);
        }
      };
      ctrl.addSmsToArchive = () => {
        const smsMessage = {
          time: moment.utc().format('X'),
          idAccount: ctrl.currentAccount.id,
          avatar: ctrl.currentAccount.user.avatar,
          userName: ctrl.currentAccount.getName(),
          sentFrom: ctrl.getCurrentSender().phone,
          sentTo:
            (ctrl.contact && ctrl.contact.id ? `${ctrl.contact.getName()} : ` : '') +
            ctrl.phone,
          message: ctrl.message,
          isSaved: false,
          isIncoming: false
        };
        if ($sessionStorage.SmsMessages.length > 1024) {
          $sessionStorage.SmsMessages.splice(0, 1024 - $sessionStorage.SmsMessages.length);
        }
        $sessionStorage.SmsMessages.push(smsMessage);
      };
      ctrl.sendMessage = () => {
        if (!ctrl.phone || !ctrl.message) {
          if (!ctrl.phone) {
            uiService.toast({
              text: {
                p1: 'Recipient',
                p2: 'phone number',
                p3: 'is required'
              },
              warn: true
            });
          }
          if (!ctrl.message) {
            uiService.toast({
              text: {
                p1: 'SMS',
                p2: 'message content',
                p3: 'is required'
              },
              warn: true
            });
          }
        } else if (Number(ctrl.getCurrentSender().phone) === Number(ctrl.phone)) {
          uiService.toast({
            text: {
              p1: 'Sender and recipient',
              p2: 'phones',
              p3: 'cannot be the same'
            },
            warn: true
          });
        } else {
          ctrl.isSendingMessage = true;
          smsService
            .send({
              sender: ctrl.getCurrentSender().phone,
              recipient: ctrl.phone,
              content: ctrl.message
            })
            .then((result) => {
              if (result && result.status) {
                ctrl.addSmsToArchive();
                ctrl.isSendingMessage = false;
                eventService.connectSmsSent();
                ctrl.message = '';
              } else {
                ctrl.isSendingMessage = false;
                ctrl.message = '';
                uiService.toast({
                  text: {
                    p1: 'Something went wrong',
                    p2: 'SMS',
                    p3: 'has not been sent'
                  },
                  warn: true
                });
              }
            });
        }
      };
      ctrl.showSaveToNoteDialog = (sms) => {
        $mdDialog
          .show({
            locals: {
              call: sms
            },
            template: templateAddAsNote,
            controllerAs: '$ctrl',
            controller(TICKET) {
              const self = this;
              this.isLoading = true;
              this.idWorkflow = null;
              this.availableWorkflows = [];
              this.idTicket = null;
              this.availableTickets = [];
              workflowsService.getAvailable({ isActive: true }).then((workflows) => {
                self.availableWorkflows = workflows;
                self.availableTickets = [];
                self.isLoading = false;
              });
              this.getTickets = () => {
                self.isLoading = true;
                self.availableTickets = [];
                ticketsService
                  .getByWorkflow({
                    idWorkflow: self.idWorkflow,
                    fields: TICKET.FIELDS.DROPDOWN
                  })
                  .then((tickets) => {
                    self.availableTickets = tickets;
                    self.isLoading = false;
                  });
              };
              this.confirmDialog = () => {
                $mdDialog.hide({ idWorkflow: this.idWorkflow, idTicket: this.idTicket });
              };
              this.cancelDialog = () => {
                $mdDialog.cancel();
              };
            }
          })
          .then((dialogResult) => {
            smsService
              .addToTicketAsNote({
                sms,
                idWorkflow: dialogResult.idWorkflow,
                idTicket: dialogResult.idTicket
              })
              .then((result) => {
                if (result && result.status) {
                  notesService.clearCache();
                  // eslint-disable-next-line no-param-reassign
                  sms.isSaved = true;
                  uiService.toast({
                    text: {
                      p1: 'Saved SMS to',
                      p2: 'deal',
                      p3: 'as a note'
                    }
                  });
                }
              });
          });
      };

      /*
       * Events
       * --------------------------------------------------------------------------------
       */
      ctrl.onPastePhone = ($event) => {
        $event.preventDefault();
        const pastedValue = $event.originalEvent.clipboardData.getData('text/plain');
        ctrl.phone = pastedValue.onlyNumbers();
      };
      ctrl.onTypingPhone = ($event) => {
        if (
          _.isNaN(String.fromCharCode($event.keyCode)) ||
          String.fromCharCode($event.keyCode) === ' '
        ) {
          $event.preventDefault();
        }
      };
      ctrl.onTyping = ($event) => {
        if ($event.keyCode === 13) {
          ctrl.sendMessage();
        }
      };

      /*
       * Helper Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.switchSender = (idSender) => {
        ctrl.sender = idSender;
      };
      ctrl.getCurrentSender = () => ctrl.getSender(ctrl.sender);
      ctrl.getSender = (idSender) => $filter('filter')(ctrl.senders, { id: idSender })[0];
      ctrl.formatTime = (time) => {
        const date = moment.utc(time, 'X').tz(ctrl.currentTimeZone);
        return `${date.format(ctrl.currentDateFormat)} ${date.format(ctrl.currentTimeFormat)}`;
      };

      /*
       * Broadcast Listeners
       * --------------------------------------------------------------------------------
       */
      eventService.onConnectSms((args) => {
        ctrl.contact = args.contact;
        ctrl.phone = ctrl.contact.getPhone().onlyNumbers();
      });
      eventService.onConnectSmsSent(() => {
        uiService.elementContentScroll('smsContent');
      });
      eventService.onConnectSmsReceived(() => {
        uiService.elementContentScroll('smsContent');
      });
      eventService.onCredentialsChanged(() => {
        ctrl.initialize();
      });

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
